import StickyEvents from 'sticky-events';
import supportsSticky from '../helpers/supports-sticky';
import NavDesktop from './nav/desktop';
import NavMobile from './nav/mobile';

import AlgoliaSearch from '../components/algolia-search';
import Vue from 'vue';

const $ = jQuery;

class Header {
    constructor(selector) {
        this.selector = selector;
        this.current = null;
        $(() => this.init());
    }

    init() {

        this.$el = $(this.selector);
        if( !this.$el.length ){
            return;
        }
        this.$subnav = this.$el.find('.header-nav__subnav');
        this.$searchResults = this.$el.find('.header-search-results');

        this.initSearch();
        this.initSticky();
        
        this.desktop = new NavDesktop(this, 'screen and (min-width: 992px)');
        this.phone = new NavMobile(this, 'screen and (max-width: 991px)');

        this.update();

    }

    initSearch() {
        this.$search = this.$el.find('.header-search-results');
        this.$searchInput = this.$el.find('input[data-target="algolia-search"]');

        this.$searchHighlight = this.$el.find('.header-search .input-highlight');
        this.$searchInput.on('input.header change.header', e => {
            this.$searchHighlight.html( this.$searchInput.val() );
        });
        this.$searchHighlight.html( this.$searchInput.val() );

        const input = this.$searchInput[0];
        
        if( theme_config.algolia && theme_config.algolia.application_id){
            const resultsEl = this.$search.find('[data-results-component]')[0];
            const suggestions = $(resultsEl).data('searchSuggestions');
            const suggestionIndexName = $(resultsEl).data('searchSuggestionIndexName');
            const v = new Vue({
                el: resultsEl,
                render: function(h){
                    return h( AlgoliaSearch, {
                        props: {
                            input,
                            config: {
                                ...theme_config.algolia,
                                ...$(resultsEl).data()
                            }
                        }
                    });
                }
            });
            this.searchComponent = v.$children[0];
        }
    }

    initSticky() {

        if( !supportsSticky ){
            return false;
        }
        this.stickyEvents = new StickyEvents({
            container: document,
            enabled: false,
            stickySelector: 'header.page-header'
        });

        const {
            stickyElements,
            stickySelector
        } = this.stickyEvents;

        stickyElements.forEach(sticky => {
            sticky.addEventListener(StickyEvents.CHANGE, event => {
                sticky.classList.toggle('-stuck', event.detail.isSticky);
            });
        });

        this.setSticky(true);

        $(document).on('scroll', () => this.update());
        $(window).on('resize orientationchange', () => this.update());
    }

    setSticky(enable){
        if( enable ){
            this.$el.css({
                'top':'',
                'position':'sticky'
            });
            this.stickyEvents.enableEvents();
        }
        else {
            this.$el.css({
                'top':'0',
                'position': 'relative'
            });
            // if this hasn't been enabled yet, don't worry about it
            if( this.stickyEvents.state.size ){
                // IMO, this should be part of the "disableEvents" function
                this.stickyEvents.state.forEach( sticky => {
                    if( sticky.headerSentinel && sticky.headerSentinel.parentNode ){
                        sticky.headerSentinel.parentNode.removeChild( sticky.headerSentinel );
                    }
                    if( sticky.footerSentinel && sticky.footerSentinel.parentNode ){
                        sticky.footerSentinel.parentNode.removeChild( sticky.footerSentinel );
                    }
                });
                this.stickyEvents.disableEvents();
            }
        }
    }

    update() {
        let height = (this.$el.offset().top + this.$el.height()) - $(window).scrollTop();
        this.$subnav.css({
            maxHeight: 'calc( 100vh - ' + height + 'px )'
        });
        height -= this.$el.find('.header-nav').height();
        this.$searchResults.css({
            maxHeight: 'calc( 100vh - ' + height + 'px )'
        });
        // lets get the rectangle
        const rect = this.$el[0].getBoundingClientRect();
        document.documentElement.style.setProperty('--asa-header-height', (rect.height + rect.top)+'px' );
    }

}

new Header('header.page-header');